var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrossBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 46,
  height: 46,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.41 14.59 23 20.17l5.59-5.58 2.82 2.82L25.83 23l5.58 5.59-2.82 2.82L23 25.83l-5.59 5.58-2.82-2.82L20.17 23l-5.58-5.59 2.82-2.82Z",
  fill: "#fff"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.67 2C4.09 2 2 4.09 2 6.67v32.66C2 41.91 4.09 44 6.67 44h32.66c2.58 0 4.67-2.09 4.67-4.67V6.67C44 4.09 41.91 2 39.33 2H6.67Zm32.66 4c.37 0 .67.3.67.67v32.66c0 .37-.3.67-.67.67H6.67a.67.67 0 0 1-.67-.67V6.67c0-.37.3-.67.67-.67h32.66Z",
  fill: "#fff"
})));
export default SvgCrossBox;